import { render, staticRenderFns } from "./LedgerInfoTab.vue?vue&type=template&id=199b3064&scoped=true"
import script from "./LedgerInfoTab.vue?vue&type=script&lang=ts"
export * from "./LedgerInfoTab.vue?vue&type=script&lang=ts"
import style0 from "./LedgerInfoTab.vue?vue&type=style&index=0&id=199b3064&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b3064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199b3064')) {
      api.createRecord('199b3064', component.options)
    } else {
      api.reload('199b3064', component.options)
    }
    module.hot.accept("./LedgerInfoTab.vue?vue&type=template&id=199b3064&scoped=true", function () {
      api.rerender('199b3064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/components/LedgerInfoTab.vue"
export default component.exports